import { useSyncExternalStore } from 'react';

export type EdmsProvisionStatus =
  | 'created'
  | 'already_exists'
  | 'role_not_found'
  | 'cooldown'
  | 'in_progress'
  | 'failed'
  | 'skipped'
  | 'unknown';

export type EdmsProvisioningSnapshot = {
  status: EdmsProvisionStatus;
  message?: string | null;
  retryAfterMs?: number | null;
  updatedAt?: number | null;
};

let currentState: EdmsProvisioningSnapshot = {
  status: 'unknown',
  updatedAt: null,
};

const listeners = new Set<() => void>();

const getSnapshot = () => currentState;

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const setEdmsProvisioningState = (
  nextState: EdmsProvisioningSnapshot
) => {
  currentState = nextState;
  listeners.forEach((listener) => listener());
};

export const useEdmsProvisioningState = () =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
